export default __webpack_public_path__ + "resources/icons/n140-85f9.webp";